// extracted by mini-css-extract-plugin
export default {"container":"BackNextButtons_container__+W3ms"};